import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import { FontIconComponent } from '@camelot/icons';
import { LayoutContentComponent, LayoutPanelComponent, LayoutWithPanelComponent, LinkComponent } from '@camelot/ui';

import { FiltersFormComponent } from './form/filters-form.component';

@Component({
  selector: 'cam-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  imports: [
    FontIconComponent,
    LayoutContentComponent,
    LayoutPanelComponent,
    LayoutWithPanelComponent,
    LinkComponent,
    FiltersFormComponent,
  ],
})
export class FiltersComponent {
  public isFilterOpen = false;

  public askValidation$ = new Subject<null>();

  public changeFilterOpen() {
    if (this.isFilterOpen) {
      this.askValidation$.next(null);
    }
    this.isFilterOpen = !this.isFilterOpen;
  }
}
